const $       = require('jquery');
const qs      = require('query-string');
const docdel  = require('./docdel');
const ai      = require('./ai');

const query = qs.parse(location.search);
const askAi = window.reader_view === 'ask_ai' || query.ai_preview

askAi ? $(ai) : $(docdel);
